export const Storage = localStorage
const base_history = require("../history")
export const history = base_history.history
export const API_URL = process.env.REACT_APP_API_URL
export const Home_URL = process.env.REACT_APP_HOME_URL
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL
export const PORT = 3000
export const TIMEZONE = 'Asia/Kolkata'
export const Global = ""
export const socketIOClient = require('socket.io-client');
export const Socket_URL = process.env.REACT_APP_SOCKET_URL; //process.env.REACT_APP_SOCKET_URL; //'http://178.159.2.178:4000';
export const socket = socketIOClient(Socket_URL, { path: `${process.env.REACT_APP_SOCKET_SUB_URL}` });
export const StatusBars = "";


